/**
 * Change grid layout
 */
class CollectionGridChange extends HTMLElement {
  /**
   * connectedCallback
   */
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('button'));

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.grid = document.querySelector(this.dataset.container);
        this.buttons.forEach((item) => {
          item.classList.remove('is-active');
          this.grid.classList.remove(item.dataset.view);
        });
        button.classList.add('is-active');
        const newView = button.dataset.view;
        this.grid.classList.add(newView);
        if (this.classList.contains('at-grid-view-container--mobile')) document.querySelector('.mobile-facets__close').click();

        const { cartAttribute } = button.dataset;

        fetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({
            attributes: {
              [cartAttribute]: newView,
            },
          }),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
          },
        })
          .then(response => { return response.text() })
          .then(cart => { return cart; });
      });
    });
  }
}
customElements.define('collection-grid-change', CollectionGridChange);
